export const getProgrammeName = (data) => {
  const programName = data?.ProgrammeName__c
    ? `${data?.ProgrammeName__c}${
        data?.Delivery_Mode__c ? `, ${data?.Delivery_Mode__c}` : ''
      }`
    : ''

  return programName ? programName : data?.Name?.split('_')[0]
}
